<template>
  <div class="nav-bg">
    <div class="row mr-8">
      <div class="col-auto">
        <router-link :to="{ path: '/Home' }" class="white--text font-18">خانه</router-link>
      </div>
      <div class="col-auto"><span @click="orderRecord" class="white--text font-18 orderRecordBtn">تاریخچه سفارشات</span>
      </div>
      <div class="col-auto">
        <router-link :to="{ path: '/allProducts' }" class="white--text font-18">همه‌ محصولات</router-link>
      </div>
<!--      <div class="col-auto">
        <router-link :to="{ path: '/BlogPosts' }" class="white&#45;&#45;text font-18">وبلاگ</router-link>
      </div>-->
      <div class="col-auto">
        <router-link :to="{ path: '/aboutUs' }" class="white--text font-18">درباره ما</router-link>
      </div>
      <div class="col-auto">
        <router-link :to="{ path: '/contactUs' }" class="white--text font-18">تماس با ما</router-link>
      </div>
      <div class="col-auto">
        <router-link :to="{ path: '/SuggestionCritic' }" class="white--text font-18">شکایات</router-link>
      </div>
      <div class="col-auto">
        <router-link :to="{ path: '/publicly' }" class="white--text font-18">قوانین و مقررات</router-link>
      </div>
<!--      <div class="col-auto col-auto pt-2 px-0 pb-0" >
        <v-btn text @click.stop="showHistoryDialog" ><span class="white&#45;&#45;text font-18">اخبار تغییر قیمت</span></v-btn>
      </div>-->
    </div>
    <v-dialog
        v-model="showResultDialog"
        persistent
        width="500">
      <v-card class="text-center pt-5">
        <v-card-text class="pb-0">
          <div class="mb-0 black--text">{{ dialogResult }}</div>

        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pt-1 pb-3">
          <v-btn block class="primary" rounded @click="showResultDialog = !showResultDialog">
            بستن
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>
<!--    <v-dialog
        v-model="showHistory"
        max-width="400px"
    >
      <v-card>
        <v-card-title class="pa-0">
          <div class="text-center primary-background black&#45;&#45;text align-self-center w-100 py-2">
            اخبار تغییر قیمت
          </div>
        </v-card-title>
        <v-card-text class="px-1 pb-1">
          <price-history-list></price-history-list>
        </v-card-text>
        <v-card-actions class="d-block">
          <v-btn @click="showHistory = false" block class="pa-0">
            <div class="text-center primary-background black&#45;&#45;text align-self-center w-100 py-2 px-3">
بستن            </div>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>-->
  </div>

</template>

<script>

export default {
  name: "navBar",
  data: () => ({
    showResultDialog: false,
    dialogResult: null,
    showHistory: false

  }),

  methods: {
    orderRecord() {
      if (this.$getUserData().token === '') {
        this.dialogResult = "برای مشاهده این بخش ابتدا باید وارد سایت شوید";
        this.showResultDialog = true;
      } else {
        this.$router.push("OrderRecords")
      }
    },
    showHistoryDialog() {
      this.showHistory = true;
    },
  }
}
</script>

<style scoped>

</style>